import { IData } from 'components/molecules/PredictionGrid/types';

export const columns: IData[] = [
  {
    name: 'collection',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 110,
    title: 'Coleta',
  },
  {
    name: 'serieNumber',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 120,
    title: 'Nº de série',
  },
  {
    name: 'tag',
    align: 'center',
    width: 100,
    title: 'TAG',
  },
  {
    name: 'calota',
    align: 'left',
    width: 130,
    title: 'Rigidez Dielétrica - Calota (kV)',
  },
  {
    name: 'neutralization',
    align: 'left',
    width: 170,
    title: 'Índice de neutralização (mgKOH/g)',
  },
  {
    name: 'color',
    align: 'center',
    width: 100,
    title: 'Cor',
  },
  {
    name: 'relativeDensity',
    align: 'left',
    width: 140,
    title: 'Densidade Relativa 20/4ºC (g/mL)',
  },
  {
    name: 'visualAspect',
    align: 'left',
    width: 120,
    title: 'Aspecto Visual',
  },
  {
    name: 'waterContentMeasured',
    align: 'left',
    width: 130,
    title: 'Teor de água (ppm) - Medido',
  },
  {
    name: 'waterContentadjusted',
    align: 'left',
    width: 150,
    title: 'Teor de água (ppm) - 20ºC - Corrigido',
  },
  {
    name: 'interfacialTension',
    align: 'left',
    width: 100,
    title: 'Tensão Interfacial',
  },
  {
    name: 'interfacialTensionMnm',
    align: 'left',
    width: 150,
    title: 'Tensão Interfacial (mN/m)',
  },
  {
    name: 'lossFactor',
    align: 'left',
    width: 120,
    title: 'Fator de Perdas 90ºC:',
  },
  {
    name: 'powerFactor',
    align: 'left',
    width: 130,
    title: 'Fator de Potência a 100ºC (%)',
  },
  {
    name: 'classification',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 130,
    title: 'Classificação',
  },
  {
    name: 'omegaClassification',
    align: 'left',
    direction: 'asc',
    sortingEnabled: true,
    width: 140,
    title: 'Classificação Omega',
  },
  {
    name: 'recommendation',
    align: 'center',
    direction: 'asc',
    sortingEnabled: true,
    width: 150,
    title: 'Recomendação',
  },
  {
    name: 'omegaRecommendation',
    align: 'left',
    sortingEnabled: true,
    width: 140,
    title: 'Recomendação Omega',
  },
];
